const { Application } = Shopware;

Application.addServiceProviderDecorator('searchTypeService', (searchTypeService) => {
    searchTypeService.upsertType('tdar_availability_request', {
        entityName: 'tdar_availability_request',
        placeholderSnippet: 'TopdataAvailabilityRequestSW6.admin.searchPlaceholder',
        listingRoute: 'tdar.availability.request.list',
        hideOnGlobalSearchBar: true,
    });

    return searchTypeService;
});
